import { Alert, IconButton, InputAdornment, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import ConfirmationModal from 'components/ConfirmationModal'
import { PATIENT_LIST } from 'navigation/CONSTANTS'
import { InputMask } from 'components/InputMask'
import InputBase from 'design-system/input/base'
import NavLinkBack from 'components/NavLinkBack'
import ButtonBase from 'design-system/button'
import InputPassword from 'design-system/input/password'
import useAddPatient from './useAddPatient'

const AddPatientPage = () => {
  const {
    disableFields,
    errors,
    isModalOpen,
    password,
    request,
    state,
    enableButton,
    addNewPatient,
    handleConfirm,
    setPassword,
    setModal,
    updatePatient
  } = useAddPatient()

  return (
    <Grid
      container
      spacing={2}
      p={2}
      width='100%'
      maxWidth={1200}
      margin='0 auto'
    >
      <NavLinkBack to={`/${PATIENT_LIST}`} />
      <Grid size={12}>
        <Typography variant='h5'>Adicionar Pacientes</Typography>
      </Grid>
      <Grid size={12}>
        <Alert variant='outlined' color='info' severity='info'>
          Primeiro digite o CPF para encontrar o paciente
        </Alert>
      </Grid>
      <Grid container size={12} spacing={3} maxWidth={1200}>
        <Grid size={6}></Grid>
        <InputMask
          placeholder='CPF'
          value={request.cpf}
          mask='000.000.000-00'
          onChange={(_, value) => updatePatient('cpf', value)}
          disabled={state === 'loading'}
          slotProps={
            state === 'loading'
              ? {
                  input: {
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton
                          size='small'
                          disabled
                          type='button'
                          loading
                        />
                      </InputAdornment>
                    )
                  }
                }
              : undefined
          }
          error={errors.has('cpf')}
          helperText={errors.get('cpf')}
        />
        <InputBase
          value={request.first_name}
          onChange={e => updatePatient('first_name', e.target.value)}
          placeholder='Nome'
          disabled={disableFields}
          error={errors.has('first_name')}
          helperText={errors.get('first_name')}
        />
        <InputBase
          value={request.last_name}
          onChange={e => updatePatient('last_name', e.target.value)}
          placeholder='Sobrenome'
          disabled={disableFields}
          error={errors.has('last_name')}
          helperText={errors.get('last_name')}
        />
        <InputMask
          value={request.mobile_phone}
          onChange={(_, value) => updatePatient('mobile_phone', value)}
          placeholder='Telefone'
          disabled={disableFields}
          mask='(00) 00000-0000'
          error={errors.has('mobile_phone')}
          helperText={errors.get('mobile_phone')}
        />
        <InputBase
          value={request.email}
          onChange={e => updatePatient('email', e.target.value)}
          placeholder='E-mail'
          disabled={disableFields}
          type='email'
          error={errors.has('email')}
          helperText={errors.get('email')}
        />
        {!disableFields && (
          <InputPassword
            label='Senha'
            type='password'
            variant='outlined'
            placeholder='******'
            value={password}
            onChange={e => setPassword(e.target.value)}
            error={errors.has('password')}
            helperText={errors.get('password')}
          />
        )}
        <ConfirmationModal
          open={isModalOpen}
          title='Confirma a adição deste paciente?'
          onConfirm={handleConfirm}
          onCancel={() => setModal(false)}
        />
        {state != 'idle' && (
          <Grid size={12} justifyContent={'end'} container>
            <ButtonBase
              loading={state == 'loading'}
              disabled={!enableButton}
              sx={{
                alignSelf: 'end'
              }}
              onClick={() => {
                if (disableFields) setModal(true)
                else addNewPatient()
              }}
            >
              {request.patient_id ? 'Vincular paciente' : 'Cadastrar paciente'}
            </ButtonBase>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default AddPatientPage
